document.addEventListener("DOMContentLoaded", () => {
  // Initialize Lenis
  const lenis = new Lenis({
    autoRaf: true
  });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}


// MENU DRAWER

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.searchButton = this.querySelector('#search-button');
    this.mobileMenuButton = this.querySelector('#mobile-menu-button')
    this.toggleButton = this.querySelectorAll('.menu-button');
    this.container = this.querySelector('.drawer-container');
    this.drawer = this.querySelector('.drawer');
    this.closeDrawerArea = this.querySelector('.close-drawer-area');
    this.closeDrawerButton = this.querySelector('.menu-drawer__close-button');
    this.addEventListener('keyup', this.onKeyUp.bind(this));

    this.bindEvents();
  }

  bindEvents() {
    if (this.toggleButton) {
      this.toggleButton.forEach(button => {
        button.addEventListener('click', this.handleToggleClick.bind(this));
      })
    }

    if (this.closeDrawerArea) {
      this.closeDrawerArea.addEventListener('click', this.closeMenuDrawer.bind(this));
    }

    if(this.searchButton) {
      this.searchButton.addEventListener('click', () => {
        const searchModal = document.querySelector('search-modal')

        if (searchModal.classList.contains('open')) {
          this.classList.remove('search-modal-is-open')
          searchModal.closeModal()
        } else {
          this.classList.add('search-modal-is-open')
          searchModal.openModal()
        }
      })
    }

    if (this.closeDrawerButton) {
      this.closeDrawerButton.addEventListener('click', this.closeMenuDrawer.bind(this));
    }

    if (this.mobileMenuButton) {
      this.mobileMenuButton.addEventListener('click', this.openMenuDrawer.bind(this));
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.closeMenuDrawer()
  }

  handleToggleClick(event) {
    if (event.target && !event.target.classList.contains('active')) {
      event.preventDefault();
    }

    const clickedButton = event.currentTarget; // this is the button that was clicked

    if (this.classList.contains('open') && clickedButton.classList.contains('active')) {
      this.closeMenuDrawer(clickedButton);
    } else {
      this.toggleButton.forEach(button => button.classList.remove('active'))
      clickedButton.classList.add('active');
      
      this.openMenuDrawer(clickedButton);
    }
  }

  openMenuDrawer() {
    this.classList.add('open');
    gsap.to(this.drawer, { x: 0, duration: 1, ease: 'expo.inOut' });
    gsap.to(this.container, { backgroundColor: 'rgba(0,0,0,0.4)', duration: 1, ease: 'expo.inOut' });
  }

  closeMenuDrawer() {
    this.classList.remove('open');

    gsap.to(this.drawer, { x: '-100%', duration: 1, ease: 'expo.inOut' });
    gsap.to(this.container, { backgroundColor: 'rgba(0,0,0,0)', duration: 1, ease: 'expo.inOut', delay: 0.6 });

    if (window.innerWidth >= 990) {
      this.toggleButton.forEach(button => button.classList.remove('active'))
    }
  }
}

// PRODUCT CARD SWIPER GALLERY

customElements.define('menu-drawer', MenuDrawer);

class CustomSwiperGallery extends HTMLElement {
  constructor() {
    super();

    this.swiper = this.querySelector('.slider');
    this.pagination = this.querySelector('.custom-pagination');
    this.controls = this.querySelectorAll('.variant-button');
    this.nextButton = this.querySelector('.arrow-next-button');
    this.previousButton = this.querySelector('.arrow-previous-button');
    this.swiping = this.dataset.swiping
    this.selectedVariant = parseInt(this.dataset.variantId)
    this.slides = this.querySelectorAll('swiper-slide')

    setTimeout(() => {
      this.initialiseSwiper()
    }, 10)
  }

  initialiseSwiper() {
    Object.assign(this.swiper, {
      initialSlide: 0,
      effect: "fade",
      noSwiping: this.swiping,
      loop: true,
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.previousButton,
      },
      speed: 500
    });

    if (this.swiper) {
      this.swiper.initialize()
    }
  }
}

customElements.define('custom-swiper-gallery', CustomSwiperGallery);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class VideoThumbPlayer extends HTMLElement {
  constructor() {
    super();
    this.background = this.querySelector('.video-thumb-player__bg');
    this.closeButton = this.querySelector('.video-thumb__close-button')
    this.videoThumbContainer = this.querySelector('.video-thumb-container')
    this.video = this.querySelector('video');

    this._isExpanded = false;

    this.eventHandlers();
  }

  eventHandlers() {
    this.closeButton.addEventListener('click', () => {
      if (this._isExpanded) {
        this.deactivateVideoPlayerWindow();
      } else {
        this.hideVideo()
      }
    })

    if (this.background) {
      this.background.addEventListener('click', (e) => {
        // Only close if clicked directly on the background
        if (this._isExpanded && e.target === this.background) {
          this.deactivateVideoPlayerWindow();
        }
      });
    }

    if (this.video) {
      this.video.addEventListener('click', () => {
        if (!this._isExpanded) {
          this.activateVideoPlayerWindow();
        }
      });
    }
  }

  hideVideo() {
    this.classList.add('hide-video');
  }

  activateVideoPlayerWindow() {
    if (this._isExpanded) return;
    this._isExpanded = true;

    this.classList.add('expanded');
    gsap.to(this.background, { backgroundColor: 'rgba(0,0,0,0.4)', duration: 1, ease: 'expo.inOut' });
    gsap.to(this.videoThumbContainer, { 
      bottom: "50%",
      right: "50%",
      x: "50%",
      y: "50%",
      width: window.innerWidth > 990 ? '33vw' : '80vw',
      duration: 1, 
      ease: 'expo.inOut' 
    });
    // Turn on controls
    this.video.controls = true;

    // Unmute
    this.video.muted = false;
  }

  deactivateVideoPlayerWindow() {
    if (!this._isExpanded) return;
    this._isExpanded = false;

    this.classList.remove('expanded');
    gsap.to(this.background, { backgroundColor: 'rgba(0,0,0,0)', duration: 1, ease: 'expo.inOut' });
    gsap.to(this.videoThumbContainer, { 
      bottom: "0%",
      right: "0%",
      x: "0%",
      y: "0%",
      width: window.innerWidth > 990 ? '234px' : '120px',
      duration: 1, 
      ease: 'expo.inOut' 
    });

    // Mute
    this.video.muted = true;

    // Turn on controls
    this.video.controls = false;

    // Resume playback (some browsers require user interaction to start sound)
    this.video.play();
  }
}

customElements.define('video-thumb-player', VideoThumbPlayer);

class ProductVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.background = this.querySelector('.product-template__video-background');
    this.closeButton = this.querySelector('.video-thumb__close-button');
    this.videoThumbContainer = this.querySelector('.video-thumb-inner');
    this.video = this.querySelector('video');

    // state used for restoration
    this._isExpanded = false;
    this._placeholder = null;
    this._originalParent = null;
    this._originalNextSibling = null;
    this._originalStyles = {};

    this.eventHandlers();
  }

  eventHandlers() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.deactivateVideoPlayerWindow.bind(this));
    }

    if (this.background) {
      this.background.addEventListener('click', (e) => {
        // Only close if clicked directly on the background
        if (this._isExpanded && e.target === this.background) {
          this.deactivateVideoPlayerWindow();
        }
      });
    }

    if (this.video) {
      this.video.addEventListener('click', () => {
        if (this._isExpanded) {
          this.deactivateVideoPlayerWindow();
        } else {
          this.activateVideoPlayerWindow();
        }
      });
    }
  }

  _makePlaceholder(rect) {
    const placeholder = document.createElement('div');
    placeholder.style.width = `${rect.width}px`;
    placeholder.style.height = `${rect.height}px`;
    placeholder.style.display = getComputedStyle(this.videoThumbContainer).display || 'block';
    // keep it invisible but preserve space
    placeholder.style.visibility = 'hidden';
    placeholder.className = 'video-thumb-placeholder';
    return placeholder;
  }

  activateVideoPlayerWindow() {
    if (this._isExpanded) return;
    this._isExpanded = true;

    // Save scroll position
    this._scrollY = window.scrollY;

    // Lock scroll
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // lock scroll
    // document.body.classList.add('overflow-hidden');
    this.classList.add('expanded');

    // get current rect in viewport coords
    const rect = this.videoThumbContainer.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // store original for restore
    this._originalParent = this.videoThumbContainer.parentNode;
    this._originalNextSibling = this.videoThumbContainer.nextSibling;
    this._originalStyles = {
      position: this.videoThumbContainer.style.position || '',
      left: this.videoThumbContainer.style.left || '',
      top: this.videoThumbContainer.style.top || '',
      width: this.videoThumbContainer.style.width || '',
      height: this.videoThumbContainer.style.height || '',
      zIndex: this.videoThumbContainer.style.zIndex || '',
      transform: this.videoThumbContainer.style.transform || '',
      transition: this.videoThumbContainer.style.transition || ''
    };

    // placeholder keeps layout stable
    this._placeholder = this._makePlaceholder(rect);
    this._originalParent.insertBefore(this._placeholder, this.videoThumbContainer);

    // move element to body so fixed positioning is safe
    document.body.appendChild(this.videoThumbContainer);

    // set it up as fixed positioned overlay at same screen position
    Object.assign(this.videoThumbContainer.style, {
      position: 'fixed',
      left: `${rect.left}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`,
      margin: '0',
      transform: 'none', // ensure no transform scaling is present
      zIndex: '10000',
      willChange: 'left, top, width, height'
    });

    // compute target size while maintaining aspect ratio, and respecting viewport
    const targetWidth = vw > 990 ? Math.min(vw * 0.33, vw * 0.9) : Math.min(vw * 0.8, vw * 0.95);
    const targetHeight = (targetWidth / rect.width) * rect.height;

    // ensure target doesn't overflow height (leave some vertical margin)
    const maxAllowedHeight = vh * 0.9;
    let finalWidth = targetWidth;
    let finalHeight = targetHeight;
    if (targetHeight > maxAllowedHeight) {
      finalHeight = maxAllowedHeight;
      finalWidth = (finalHeight / targetHeight) * targetWidth;
    }

    const targetLeft = Math.round((vw - finalWidth) / 2);
    const targetTop = Math.round((vh - finalHeight) / 2);

    // animate background and the fixed element using left/top/width/height (no scale)
    gsap.timeline({ defaults: { duration: 0.9, ease: 'expo.inOut' } })
      .to(this.background, { backgroundColor: 'rgba(0,0,0,0.4)' }, 0)
      .to(this.videoThumbContainer, {
        left: `${targetLeft}px`,
        top: `${targetTop}px`,
        width: `${finalWidth}px`,
        height: `${finalHeight}px`
      }, 0);

    // video UI
    this.video.controls = true;
    this.video.muted = false;
  }

  deactivateVideoPlayerWindow() {
    if (!this._isExpanded) return;
    this._isExpanded = false;

    // Restore scroll lock state
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    // Restore scroll position
    window.scrollTo(0, this._scrollY || 0);

    // document.body.classList.remove('overflow-hidden');
    this.classList.remove('expanded');

    // original placeholder rect (in case the page scrolled while expanded, we recalc)
    // We want to animate back to the *current* screen rect of the placeholder.
    const placeholderRect = this._placeholder.getBoundingClientRect();

    // animate background and element back to placeholder rect
    gsap.timeline({ defaults: { duration: 0.9, ease: 'expo.inOut' } })
      .to(this.background, { backgroundColor: 'rgba(0,0,0,0)' }, 0)
      .to(this.videoThumbContainer, {
        left: `${placeholderRect.left}px`,
        top: `${placeholderRect.top}px`,
        width: `${placeholderRect.width}px`,
        height: `${placeholderRect.height}px`,
        onComplete: () => {
          // restore to original place in DOM
          if (this._originalParent) {
            if (this._originalNextSibling) {
              this._originalParent.insertBefore(this.videoThumbContainer, this._originalNextSibling);
            } else {
              this._originalParent.appendChild(this.videoThumbContainer);
            }
          }

          // remove placeholder
          if (this._placeholder && this._placeholder.parentNode) {
            this._placeholder.parentNode.removeChild(this._placeholder);
            this._placeholder = null;
          }

          // restore original inline styles
          Object.assign(this.videoThumbContainer.style, this._originalStyles);
          this.videoThumbContainer.style.willChange = '';
        }
      }, 0);

    // video UI
    this.video.controls = false;
    this.video.muted = true;

    // resume playback (some browsers require user interaction)
    this.video.play();
  }
}

customElements.define('product-video-player', ProductVideoPlayer);

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
    this.limit = window.innerWidth < 990 ? 4 : 8

    this.eventHandlers()
  }

  eventHandlers() {
    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };
    
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        this.limit = 3
      } else {
        this.limit = 4
      }

      this.initializeRecommendations(this.dataset.productId);
    };

    window.addEventListener('resize', debounce(handleResize, 300));
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 0px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}?limit=${this.limit}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

document.addEventListener('DOMContentLoaded', () => {
  const { hash } = window.location;

  // Prevent the browser from instantly jumping to the hash
  if (hash) {
    window.scrollTo(0, 0); // reset scroll position before doing anything
    history.scrollRestoration = 'manual'; // prevents browser auto scroll restore
  }

  // Then smooth scroll to the target after layout is ready
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }
});

class ProductTemplateImages extends HTMLElement {
  constructor() {
    super();
    this.zoomContainer = this.querySelector('.zoom-container');
    this.scroller = this.querySelector('.zoom-container__inner');
    this.thumbnailList = this.querySelector('#zoom-thumbnnail-list');
    this.thumbButtons = this.querySelectorAll('.thumb-btn');
    this.image = this.querySelectorAll('.product-image');
    this.closeButton = this.querySelector('.zoom-container-close');
    this._isExpanded = false;
    this.bindEvents();
    this.initScrollSpy();
  }

  bindEvents() {
    if (this.image) {
      this.image.forEach(image => {
        image.addEventListener('click', this.open.bind(this));
      })
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }

    // CLICK TO SCROLL LOGIC
    this.thumbButtons.forEach(button => {
      const targetImgElement = document.getElementById(button.dataset.targetId)
      button.addEventListener('click', () => {
        this.highlightThumbnail(button.dataset.targetId)
        // Scroll the actual image into view
        targetImgElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    if (this._isExpanded) {
      this.close()
    }
  }

  open() {
    if (this._isExpanded) return;
    this._isExpanded = true;

    document.addEventListener('keyup', this.onKeyUp.bind(this));

    // Save scroll position
    this._scrollY = window.scrollY;

    // Lock scroll
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this._scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // lock scroll
    // document.body.classList.add('overflow-hidden');
    this.classList.add('expanded');
    gsap.to(this.zoomContainer, { y: 0, duration: 1, ease: 'expo.inOut' });
  }

  close() {
    if (!this._isExpanded) return;
    this._isExpanded = false;

    document.removeEventListener('keyup', this.onKeyUp.bind(this));

    // Restore scroll lock state
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';

    // Restore scroll position
    window.scrollTo(0, this._scrollY || 0);
    this.classList.remove('expanded');

    gsap.to(this.zoomContainer, { y: '100%', duration: 1, ease: 'expo.inOut' });
  }

  /**
   * 4. The Scroll Spy (Intersection Observer)
   */
  initScrollSpy() {
    const zoomedImages = this.scroller.querySelectorAll('.zoom-image');
    // Configuration: Threshold 0.5 means trigger when 50% of image is visible
    const options = {
      root: this.scroller, // The scrollable container
      rootMargin: '0px',
      threshold: 0.5 
    };

    this._observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.highlightThumbnail(entry.target.id);
        }
      });
    }, options);

    // Observe all images in the slot
    zoomedImages.forEach(img => this._observer.observe(img));
  }

  /**
   * Helper to toggle classes
   */
  highlightThumbnail(imageId) {
    const buttons = this.thumbnailList.querySelectorAll('.thumb-btn');

    buttons.forEach(btn => {
      if (btn.dataset.targetId === imageId) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }
}

// PRODUCT CARD SWIPER GALLERY

customElements.define('product-template-images', ProductTemplateImages);